import { DOLink as WalrusDOLink } from '@do/walrus';
import styled from 'styled-components';
import newBrandDesignVars from './overwrite-vars.scss';

const NewDOLink = styled(WalrusDOLink)`
  color: ${newBrandDesignVars.primary};
  text-decoration: underline;
`;

export default NewDOLink;
